import { creators } from './remove'

export const add = (history, params) => () =>
    history.push(`/${params.domain}/mail/add`)

export const update = (history, domain, mailbox, type) => () =>
    history.push(`/${domain}/mail/${mailbox.username}/update/${type}`)

export const remove = creators.remove
